import { createSlice } from "@reduxjs/toolkit";
import {
  fetchFavoriteStudents,
  addFavoriteStudent,
  removeFavoriteStudent,
} from "./operation.js";

const teacherFavoritesSlice = createSlice({
  name: "teacherFavorites",
  initialState: {
    favorites: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavoriteStudents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFavoriteStudents.fulfilled, (state, action) => {
        state.loading = false;
        state.favorites = action.payload;
      })
      .addCase(fetchFavoriteStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addFavoriteStudent.fulfilled, (state, action) => {
        state.favorites.push(action.payload);
      })
      .addCase(removeFavoriteStudent.fulfilled, (state, action) => {
        state.favorites = state.favorites.filter(
          (s) => s.id !== action.payload
        );
      });
  },
});

export default teacherFavoritesSlice.reducer;
